// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","314":"setting"}[chunkId] + "." + {"177":"e63b9d38","314":"25833dc5"}[chunkId] + ".js";
};